import { render, staticRenderFns } from "./ProductOrder.vue?vue&type=template&id=9edae4d4&scoped=true&"
import script from "./ProductOrder.vue?vue&type=script&lang=js&"
export * from "./ProductOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edae4d4",
  null
  
)

export default component.exports